export default {"src":"/_next/static/media/logo.af1fd45e.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};